import { utils, writeFile } from "xlsx";
import dayjs from "dayjs";

/**
 * get the changed field comparing 2 forms objects
 * @param form1 the first form to compare
 * @param form2 the second form to compare
 * @returns object contains the changed fields
 */
export function resolveUpdated(form1, form2) {
  const toSave = {};
  for (const key in form1) {
    if (Object.hasOwnProperty.call(form1, key)) {
      if (form1[key] != form2[key] || key === "id") {
        toSave[key] = form1[key];
      }
    }
  }

  return toSave;
}
/**
 * get file mime type
 * @param file the file which we want to know its type
 * @returns the mime type of the file
 */
export function getMimeType(file, fallback = null) {
  const byteArray = new Uint8Array(file).subarray(0, 4);
  let header = "";
  for (let i = 0; i < byteArray.length; i++) {
    header += byteArray[i].toString(16);
  }
  switch (header) {
    case "89504e47":
      return "image/png";
    case "47494638":
      return "image/gif";
    case "ffd8ffe0":
    case "ffd8ffe1":
    case "ffd8ffe2":
    case "ffd8ffe3":
    case "ffd8ffe8":
      return "image/jpeg";
    default:
      return fallback;
  }
}
/**
 * format the date to (Date إلى Date)
 */
export function rangeDateFormat(dateString) {
  return dateString.replace(/\s/g, "").split("إلى");
}
/**
 * get File from URL
 */
export async function getFileFromUrl(url, fileName = "file") {
  return await fetch(url)
    .then((res) => res.blob())
    .then((blob) => {
      var file = null;
      file = new File([blob], fileName);
      return file;
    });
}
/**
 * download a file for a specific name
 * @param file : a blob or file object to download
 * @param name : the name you want for downloaded file
 */
export function downloadFile(file, name = "file.xlsx") {
  const href = URL.createObjectURL(file);
  const link = document.createElement("a");
  link.href = href;
  link.setAttribute("download", name);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(href);
}

/**
 * get years options from a specific year
 * @param year : the start year
 * @return array of years from the start
 */
export function getYearsOptions(year = 1950) {
  var x = [];
  for (let index = year; index <= dayjs().year(); index++) {
    x.push(`${index}`);
  }
  return x.reverse();
}

export function hasError(status) {
  return status >= 400 && status <= 500;
}
export function ifSpecifiedPeriodHasExceeded(endData){
  let currentDate = new Date();
  let date1 = new Date(`${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-${currentDate.getDate()}`);
  let date2 = new Date(`${endData}`);
  if (date1.getTime() >= date2.getTime()) {
    return true
  }else{
    return false
  }

}

  const differenceInDays = differenceInTime / (1000 * 3600 * 24);
export function differenceInTime (fisrtData , secondData , difference ){
  const date1 = new Date(fisrtData);
  const date2 = new Date(secondData);

  const differenceInTime = date2.getTime() - date1.getTime();
  const differenceInDays = differenceInTime / (1000 * 3600 * 24);
  console.log("differenceInTime" , Math.abs(differenceInTime))
  console.log("differenceInDays" , Math.abs(differenceInDays))
  if(fisrtData === undefined || secondData === undefined  ){
    return false
  }
  else if (Math.abs(differenceInDays) >= difference && date2.getTime() > date1.getTime()) {
    return false
  } else {
      return true
  }

}
export function arrangement(num) {
  if(num === 1){
    return 'الأول'
  }
  else if(num === 2){
    return 'الثاني'
  }
  else if(num === 3){
    return 'الثالث'
  }
  else if(num === 4){
    return 'الرابع'
  }
  else if(num === 5){
    return 'الخامس'
  }
  else if(num === 6){
    return 'السادس'
  }
  else if(num === 7){
    return 'السابع'
  }
  else if(num === 8){
    return 'الثامن'
  }
  else if(num === 9){
    return 'التاسع'
  }
  else if(num === 10){
    return 'العاشر'
  }
  else if(num === 11){
    return 'الحادي عشر'
  }
  else if(num === 12){
    return 'الثاني عشر'
  }
  else if(num === 13){
    return 'الثالث عشر'
  }
  
  else {
    return num
  }
}
